import { call } from 'redux-saga/effects';
import { signalingPollResultsSharingStopped } from 'features/polls/actions';
import { closeSharedPollNotificationSaga } from 'features/polls/sagas/closeSharedPollNotificationSaga';

export function* onPollResultsSharingStoppedSaga(
  action: ReturnType<typeof signalingPollResultsSharingStopped>
) {
  yield call(closeSharedPollNotificationSaga, action.payload.id);
}
